import React, { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import myFunctions from '../myFunctions';

const PopUpOneLine = (props) => {


    const [open, setOpen] = useState(true);
    const [inputTxt, setInputTxt] = useState("");
    const [err, setErr] = useState((props.errorMsg == "") ? false : true);

    const handleClose = () => {
        setOpen(false);
        // תן זמן לאנימציה להסתיים לפני שתבצע את הפעולה בפועל
        setTimeout(() => {
            if (props.cancelClick) {
                props.cancelClick();
            }
        }, 300); // משך האנימציה
    };

    myFunctions.useEscapeKey(handleClose);

    return (
        <Dialog
            open={open}
            className={`textSizeDiag popDiagBlock ${props.cssStyl || ""}`}
            onClose={handleClose}
            disableEscapeKeyDown
        >
            <div className="headAndBtnWrap spaceButtomBig">
                {/* <div className="backS">
                    <Close className="pointing" onClick={() => handleClose()} />
                </div> */}
                <div className="bold veryBig spacePadBig">
                    {props.topTitle ? props.topTitle : ""}
                </div>
                <div className="lineDotted"></div>
            </div>
            {props.topImg && <div className="imgblok" style={{ backgroundImage: `url(${props.topImg})` }}></div>}
            <div className="firstMastSec">
                <div className="insideFrame">
                    <DialogTitle className="regularFont noPadding normalLine">
                        {props.Title.map((txtItm, index) => (
                            <span key={index} className="big arrowing">{txtItm}  <br /></span>
                        ))}
                    </DialogTitle>
                    <DialogActions>
                        <div className="fullRow">
                            <div className="fullRow">
                                <button type="button" className="btnReset connectBtn conClear bold big pointing" onClick={() => props.btn1Clck()}>{props.btn1Txt}</button>
                            </div>
                            <br />
                            <div className="fullRow">
                                <button type="button" className="btnReset connectBtn conClear2 bold big pointing" onClick={() => props.btn2Clck()}>{props.btn2Txt}</button>
                            </div>
                        </div>
                    </DialogActions>
                </div>
            </div>
        </Dialog>

    );
}

export default PopUpOneLine;